import { Module } from 'vuex';
import { NodeModelStoreModule, NodeModelStoreState } from '@/store/nodeModel';
import { LayerName } from '@etp/etp-pipelines-client/axios';
import { PipelinesStoreModule, PipelinesStoreState } from '@/store/pipelines';

const getDefaultState = () => {
  return {
    ...new NodeModelStoreModule('model').state,
    ...new PipelinesStoreModule(LayerName.ModelLayer).state
  };
};

interface ModelState extends NodeModelStoreState, PipelinesStoreState {}

const nodeModelStore = new NodeModelStoreModule('model');
const pipelinesStore = new PipelinesStoreModule(LayerName.ModelLayer);

class ModelModule implements Module<ModelState, any> {
  namespaced = true;
  state = {
    ...nodeModelStore.state,
    ...pipelinesStore.state
  };
  getters = {
    ...nodeModelStore.getters,
    ...pipelinesStore.getters
  };
  actions = {
    ...nodeModelStore.actions,
    ...pipelinesStore.actions
  };
  mutations = {
    ...nodeModelStore.mutations,
    ...pipelinesStore.mutations,
    RESET_STATE(state: ModelState) {
      Object.assign(state, getDefaultState());
    }
  };
}

export default new ModelModule();
